import axios from "axios";

export function fetchShops() {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/si/shops/bulk`
  };
  return axios(config);
}

export function fetchShopInfo(id) {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/si/shops/${id}`
  };
  return axios(config);
}

export function fetchShopEdit(id) {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/si/shops/${id}`
  };
  return axios(config);
}

export function fetchSiAccounts() {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/si/si-accounts`
  };
  return axios(config);
}

export function fetchQrcode(id) {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/si/shops/${id}/qrcode`
  };
  return axios(config);
}

export function fetchRichmenus() {
  let configBusiness = {
    method: "GET",
    url: `${process.env.VUE_APP_APIHOST}/si/richmenus`
  };
  return axios(configBusiness);
}